import React from "react";
import { Card, Dropdown, Form } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaPhone } from "react-icons/fa";
import { BiMessageRounded } from "react-icons/bi";

export default function TicketCard({ ticket, onEdit, onDelete }) {
  return (
    <Card
      className="mb-3"
      style={{
        borderRadius: "5px",
        border: "1px solid #e5e7eb",
        boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
      }}
    >
      <Card.Body style={{ padding: "16px" }}>
        {/* TOP */}
        <div className="d-flex justify-content-between align-items-start">
          <Form.Check />

          {/* AVATAR */}
          <div style={{ position: "relative" }}>
            <img
              src={ticket.img}
              alt=""
              style={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                border: "2px solid #ff6b00",
                padding: 3,
                objectFit: "cover",
              }}
            />

            {/* ONLINE DOT */}
            <span
              style={{
                position: "absolute",
                bottom: 4,
                right: 4,
                width: 10,
                height: 10,
                background: "#22c55e",
                borderRadius: "50%",
                border: "2px solid #fff",
              }}
            />
          </div>

          {/* MENU */}
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="light"
              size="sm"
              style={{
                border: "none",
                background: "transparent",
                padding: 4,
              }}
            >
              <BsThreeDotsVertical size={16} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={onEdit}>Edit</Dropdown.Item>
              <Dropdown.Item onClick={onDelete}>Delete</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* TITLE */}
        <div className="text-center mt-2">
          <h6
            style={{
              fontSize: "14px",
              fontWeight: 600,
              marginBottom: 4,
            }}
          >
            {ticket.title}
          </h6>

          <span
            style={{
              background: "#e0ecff",
              color: "#2563eb",
              fontSize: "11px",
              padding: "3px 8px",
              borderRadius: "6px",
            }}
          >
            {ticket.code}
          </span>
        </div>

        {/* DETAILS */}
        <div style={{ marginTop: 16 }}>
          {/* CATEGORY */}
          <div className="d-flex justify-content-between mb-2">
            <span style={{ fontSize: 13, color: "#6b7280" }}>
              Category
            </span>
            <span style={{ fontSize: 13, fontWeight: 500 }}>
              {ticket.category}
            </span>
          </div>

          {/* STATUS */}
          <div className="d-flex justify-content-between mb-2">
            <span style={{ fontSize: 13, color: "#6b7280" }}>
              Status
            </span>

            <span
              style={{
                background: "#ffe4ec",
                color: "#ec4899",
                fontSize: 11,
                padding: "2px 8px",
                borderRadius: 6,
                display: "flex",
                alignItems: "center",
                gap: 4,
              }}
            >
              ● {ticket.status}
            </span>
          </div>

          {/* PRIORITY */}
          <div className="d-flex justify-content-between">
            <span style={{ fontSize: 13, color: "#6b7280" }}>
              Priority
            </span>

            <span
              style={{
                border:
                  ticket.priority === "High"
                    ? "1px solid #ef4444"
                    : "1px solid #94a3b8",
                color:
                  ticket.priority === "High"
                    ? "#ef4444"
                    : "#334155",
                fontSize: 11,
                padding: "2px 8px",
                borderRadius: 6,
                display: "flex",
                alignItems: "center",
                gap: 4,
              }}
            >
              ● {ticket.priority}
            </span>
          </div>
        </div>

        {/* FOOTER */}
        <div
          className="d-flex justify-content-between align-items-center mt-3 pt-3"
          style={{ borderTop: "1px solid #eee" }}
        >
          <div>
            <div style={{ fontSize: 11, color: "#6b7280" }}>
              Assigned To
            </div>

            <div className="d-flex align-items-center mt-1">
              <img
                src="/assets/img/profiles/avatar-05.jpg"
                alt=""
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  marginRight: 6,
                }}
              />
              <span style={{ fontSize: 13 }}>
                {ticket.user}
              </span>
            </div>
          </div>

          {/* ICONS */}
          <div className="d-flex align-items-center gap-2">
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                background: "#fff4ed",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <BiMessageRounded size={16} color="#ff6b00" />
            </div>

            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                background: "#f3f4f6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FaPhone size={14} color="#6b7280" />
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}